import { render } from "./LocationList.vue?vue&type=template&id=04694710"
import script from "./LocationList.vue?vue&type=script&lang=js"
export * from "./LocationList.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__